import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import find from 'lodash/find'
import get from 'lodash/get'
import * as timesheetHelper from '../../helpers/timesheet'
import { statusColor } from '../../helpers/color'
import * as CONSTANTS from '../../constants'

export const InfoData = (props) => {
  const { project } = props
  const projects = get(props, 'timesheetRequest.projects', [])
  const projectData = timesheetHelper.findProject(project.project_id, projects)

  return (
    <Wrap>
      <Row>
        <CircleCol>
          <Detail>
            { <Status color={ statusColor(get(project, 'status', CONSTANTS.NONSUBMIT)) } /> }
          </Detail>
        </CircleCol>
        <CodeCol>
          <Detail>{ get(projectData, 'project_code') }</Detail>
        </CodeCol>
        <FirstCol>
          <Detail>{ get(projectData, 'name') }</Detail>
        </FirstCol>
      </Row>
    </Wrap>
  )
}

export const TaskData = (props) => {
  const { task } = props
  let location = find(props.locations, { value: task.location_id })
  if (location === undefined) {
    location = find(props.locations, { code: 'BKK' })
  }
  return (
    <Row>
      <LocationCol>
        <Task>{ get(location, 'label') }</Task>
      </LocationCol>
      <TaskCol>
        <Task>{ get(task, 'task_name') }</Task>
      </TaskCol>
    </Row>
  )
}

InfoData.propTypes = {
  project: PropTypes.object,
}
InfoData.defaultProps = {
  project: {},
}
TaskData.propTypes = {
  task: PropTypes.object,
  locations: PropTypes.array,
}
TaskData.defaultProps = {
  locations: [],
  task: {},
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  margin-left: 1% !important;
  @media (max-width: 575.98px) {
   width: 100%;
  }
  @media (max-width: 767.98px) {
   width: 100%;
  }
  span {
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    line-height: 40px;
    pointer-events:none;
  }
  span:after {
    content:"";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events:initial;
  }

  .tooltip {
    width: 100%;
    font-size: 12px;
    top: 30px;
    background-color: #fff;
    padding: 5px;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }
  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
`
const Task = styled.span`
  font-size: 12px;
  font-family: 'Gotham-Bold' !important;
  overflow: hidden;
  margin-bottom: 0px;
  font-weight: normal;
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 15px;
  width: 15px;
  background-color: #D44B49;
  border-radius: 50%;
  margin-top: 3px;
  cursor: pointer;
`
const Status = styled(Circle)`
  background-color: ${props => props.color};
  height: 10px;
  width: 10px;
`
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  margin-left: 1% !important;
  @media (max-width: 575.98px) {
    width: 100%;
  }
  @media (max-width: 767.98px) {
    width: 100%;
  }
`
const FirstCol = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const CodeCol = styled(FirstCol)`
  width: 20%;
  padding-right: 5px;
`
const CircleCol = styled(FirstCol)`
  width: 5%;
`
const TaskCol = styled.div`
  width: 60%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`
const Title = styled.p`
  margin-bottom: 0px;
  font-weight: normal;
`
const Detail = styled(Title)`
  font-size: 12px;
  height: 25px;
  font-family: 'Gotham-Bold' !important;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`
const LocationCol = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  padding-right: 10px;
  margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/info-col-mobile.js